import React, { createContext, useContext, useState } from "react";
import { adminLogin } from "@/lib/api";

const AdminContext = createContext(null);
const KEY = "dd_admin_token";

export function AdminProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(KEY) || "");

  const login = async (email, password) => {
    const data = await adminLogin(email, password);
    localStorage.setItem(KEY, data.token);
    setToken(data.token);
    return data;
  };

  const logout = () => {
    localStorage.removeItem(KEY);
    setToken("");
  };

  return (
    <AdminContext.Provider value={{ token, isAuthed: !!token, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
}

export const useAdmin = () => useContext(AdminContext);
